import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { User } from '../shared/models/user.model';
import { CountAndResults, Email, EmailAndPassword, Token, TokenAndPassword, UserSearch } from '../shared/types';

@Injectable()
export class UserService {
  private http = inject(HttpClient);


  login(emailAndPassword: EmailAndPassword): Observable<Token> {
    return this.http.post<Token>('/api/login', emailAndPassword);
  }

  register(user: User): Observable<void> {
    return this.http.post<void>('/api/register', user);
  }

  forgotPassword(email: Email): Observable<void> {
    return this.http.post<void>('/api/forgot', email);
  }

  resetPassword(tokenAndPassword: TokenAndPassword): Observable<void> {
    return this.http.post<void>('/api/reset', tokenAndPassword);
  }

  search(body: UserSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/users/search', body);
  }

  get(id: string): Observable<User> {
    return this.http.get<User>(`/api/user/${id}`);
  }

  getDirectors(): Observable<User[]> {
    return this.http.get<User[]>(`api/users/directors`);
  }

  update(user: User): Observable<void> {
    return this.http.put<void>(`/api/user/${user._id}`, user);
  }

  updateJob(user: User): Observable<void> {
    return this.http.put<void>(`/api/user/${user._id}/updateJob`, user);
  }

  disable(user: User): Observable<void> {
    return this.http.delete<void>(`/api/user/${user._id}/disable`);
  }

  delete(user: User): Observable<void> {
    return this.http.delete<void>(`/api/user/${user._id}`);
  }

}
